import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, Modal, Form, Input } from 'antd'
import ReservationAction from 'redux/reservation/actions'
import './ProfileModal.css'

const mapStateToProps = ({ dispatch, reservation }) => ({
  dispatch,
  first_name: reservation?.first_name,
  phone_number: reservation?.phone_number,
  email: reservation?.email,
  visible: reservation?.profilePopUp,
  is_popup: reservation?.isPopup,
  loading: reservation?.loading,
  theme_color: reservation?.reservationSetupDetails?.theme_color || '#c71d11',
})

const ProfileModal = ({
  visible,
  first_name,
  phone_number,
  email,
  loading,
  theme_color,
  is_popup,
  dispatch,
  business_id,
  intl: { formatMessage },
}) => {

  const onUpdate = (values) => {
    const payload = {
      first_name: values.first_name,
      email: values.email,
      is_popup,
      business_id,
    }
    dispatch({
      type: ReservationAction.UPDATE_CUSTOMER,
      payload,
    })
  }

  const onCancel = () => {
    dispatch({
      type: ReservationAction.SET_STATE,
      payload: {
        profilePopUp: false,
      },
    })
  }

  return (
    <Modal visible={visible} onCancel={onCancel} footer={null} centered width={460}>
      <Form
        initialValues={{ first_name, phone_number, email }}
        requiredMark={false}
        layout="vertical"
        autoComplete='off'
        onFinish={onUpdate}
      >
        <div className='profile-modal'>
          <div className='profile-header'>
            <h3 className="profile-title">Profile</h3>
            <p className="profile-sub-text">Manage your profile information here</p>
          </div>
          <Form.Item
            name="first_name"
            rules={[{ required: true, message: 'Name is required' }]}
          >
            <Input
              placeholder={formatMessage({ id: 'form.label.fullName' })}
              size="large"
              style={{ fontSize: 18, height: 50 }}
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              { required: false },
              { type: 'email', message: formatMessage({ id: 'form.error.email.type' }) },
              { max: 64, message: formatMessage({ id: 'form.error.email.max' }) },
            ]}
          >
            <Input
              size="large"
              type="email"
              placeholder={formatMessage({ id: 'form.label.email' })}
              maxLength={64}
              style={{ fontSize: 18, height: 50 }}
            />
          </Form.Item>
          <Form.Item
            name="phone_number"
            rules={[{ required: true, message: 'Mobile number is required' }]}
          >
            <Input
              placeholder='Mobile Number'
              size="large"
              style={{ fontSize: 18, height: 50 }}
              readOnly
            />
          </Form.Item>
        </div>
        <div className="text-right">
          <Form.Item>
            <Button size="large" type="danger" htmlType="submit" style={{ fontSize: 18, height: 50, borderRadius: 5, backgroundColor: theme_color, borderColor: theme_color }} loading={loading} block>
              {first_name && (
                <span>{formatMessage({ id: 'action.updateProfile' })}</span>
              )}
              {!first_name && (
                <span>{formatMessage({ id: 'action.createProfile' })}</span>
              )}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}

export default connect(mapStateToProps)(injectIntl(ProfileModal))
